import React, { Component } from 'react'
import * as _ from 'lodash';
import Validator from 'validatorjs';
import { Form } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import { RegimenFiscalCatalog } from '../../../../support/catalogs';

class EmisorFiscalInfoForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      regimes: [
        {
          label: 'Selecciona Régimen Fiscal',
          value: ''
        }
      ]
    };
  }

  get rules() {
    return {
      'razon_social': ['required'],
      'rfc': ['required'],
      'regimen': ['required'],
      'email': ['required', 'email'],
      'RegistroPatronal': [
        'string',
        'min:1',
        'max:20',
        'regex:/^[^|]{1,20}$/',
      ]
    }
  }

  componentDidMount() {
    const { data } = this.props;

    if (!!data.rfc) {
      this.handleOnChange({});

      this.setRegimes(data.rfc);
    }
  }

  setRegimes = (rfc) => {
    let base = [{
      label: 'Selecciona Régimen Fiscal',
      value: ''
    }];

    const filtered = RegimenFiscalCatalog.filter((item) => {
      if (rfc.length === 13) {
        return item.fisica === 'Sí';
      }

      return item.moral === 'Sí';
    }).map((item) => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    })

    const regimes = _.sortBy(filtered, 'label');

    this.setState({
      regimes: base.concat(regimes)
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
      nomina: {
        ...this.props.data.nomina,
        ...value,
      }
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: 'fiscal_info',
      isValid: validator.passes()
    });
  }

  render() {
    const { data, autoFocus, readOnly = true } = this.props;
    const { regimes } = this.state;
    const rules = this.rules;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Razón social"
          name="razon_social"
          placeholder=""
          help=""
          readOnly={ readOnly }
          autoFocus={ autoFocus }
          rules={ rules.razon_social }
          value={ data.razon_social }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="RFC"
          name="rfc"
          placeholder=""
          help=""
          readOnly={ readOnly }
          rules={ rules.rfc }
          value={ data.rfc }
          onChange={ this.handleOnChange }
        />

        <FormControl type="select"
          label="Régimen Fiscal"
          name="regimen"
          placeholder=""
          help=""
          rules={ rules.regimen }
          value={ data.regimen }
          options={ regimes }
          onChange={ this.handleOnChange }
        />

        <FormControl type="email"
          label="Email"
          name="email"
          placeholder="email@example.com"
          help=""
          rules={ rules.email }
          value={ data.email }
          onChange={ this.handleOnChange }
        />

        <strong>NÓMINA</strong>

        <FormControl type="text"
          label="Registro Patronal"
          name="RegistroPatronal"
          placeholder=""
          help=""
          rules={ rules.RegistroPatronal }
          value={ data.nomina?.RegistroPatronal }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default EmisorFiscalInfoForm;